class CapShowPreviousRouteStatus {
    constructor(config) {
        this.config = config
    }

    // eslint-disable-next-line
    checkPermission(options = {}) {
        return Boolean(this.config)
    }
}

function key() {
    return 'show_previous_route_status'
}

function create(config) {
    return new CapShowPreviousRouteStatus(config)
}

export default {
    key,
    create,
}
